import { getFileContent } from '../../helpers/utilityFunctions';
import { browseAPIhandler } from '../../helpers/browseAPIhandler';

const { regenTokenandBrowse } = browseAPIhandler();

// to get solutions catalog-data
const getSolutionsData = (url) => {
  const solData = getFileContent(
    `${url}?resourcePath=solutions&resourceName=solutions-catalog.json`,
    regenTokenandBrowse,
  );
  // if (solData.type === 'success') {
  return solData;
  // }
  // return 'No Content';
};

// to get solutions image
const getSolutionsImg = (url, solution, imageName) => {
  const solImg = getFileContent(
    `${url}?resourcePath=solutions/${solution}/resourcess&resourceName=${imageName}`,
    regenTokenandBrowse,
  );
  if (solImg.type === 'success') {
    return solImg;
  }
  return 'No Content';
};

// get individual solution use-case details from md file
const getSolutionDetails = (url, solution, mdfileKey) => {
  const solData = getFileContent(
    `${url}?resourcePath=solutions/${solution}&resourceName=${mdfileKey}.md`,
    regenTokenandBrowse,
  );
  return solData;
};

//get solution details apis involved from the contents repo
const getSolutionDetailApisInvolved = (url, solution, filteredCatalogLatestVersion) => {
  const solData = getFileContent(
    `${url}?resourcePath=solutions/${solution}&resourceName=${solution}-apis.json`,
    regenTokenandBrowse,
  );
  if (solData.type === 'success') {
    const apiInvolvedRes = filteredCatalogLatestVersion.filter((obj) =>
      Object.values(solData.response)[0].includes(obj.name),
    );
    //checking if the solution has api or not
    if (Object.values(solData.response)[0].includes('authorization-api')) {
      //checking if final result already has the api
      if (!apiInvolvedRes.some((x) => x.name === 'authorization-api')) {
        //checking if auth refactor is enable in case of authorization being remove from the catalog DB
        const enableAUthRefactor = process.env.REACT_APP_AUTHREFACTOR
          ? process.env.REACT_APP_AUTHREFACTOR === true ||
            process.env.REACT_APP_AUTHREFACTOR.toLocaleLowerCase() === 'true'
          : false;
        if (enableAUthRefactor === true) {
          apiInvolvedRes.unshift({
            api_display_name: 'Authorization',
            api_summary: "Authorization for SVB's Commercial Banking APIs.",
            name: 'authorization-api',
            link: '/apis/authorization',
          });
        }
      }
    }
    return { type: 'success', response: apiInvolvedRes };
  }
  return [];
};

// dynamically build solution tabs from catalog
const buildSolutionTabs = (catalog) => {
  const itemList = {};
  const labelList = [];
  const keyList = [];
  for (let i = 0; i < catalog.length; i++) {
    let title = `${catalog[i].title}`;
    let content = catalog[i].content;
    labelList.push(title);
    itemList[title] = content;
    keyList[content] = title;
  }
  return [itemList, labelList, keyList];
};

// get solution tab content from json
const getSolutionTab = (url, solution) => {
  if (solution === 'no-tabs') {
    return 'No Content';
  }

  const solTab = getFileContent(
    `${url}?resourcePath=solutions/${solution}&resourceName=config.json`,
    regenTokenandBrowse,
  );
  // if (solTab.type === 'success') {
  return solTab;
  // }
  // return 'No Content';
};

export {
  getSolutionsData,
  getSolutionsImg,
  buildSolutionTabs,
  getSolutionTab,
  getSolutionDetails,
  getSolutionDetailApisInvolved,
};
